module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Thin.adae207c.otf";